/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseMediaCarouselFragment} from '@amblique/contentful/app/contentful/fragments/media-carousel/base-media-carousel.fragment';
import {CarouselItemFragment} from '@amblique/contentful/app/contentful/fragments/carousel-item/carousel-item.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {RichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/rich-text-block.fragment';
import {SectionPanelFragment} from '@amblique/contentful/app/contentful/fragments/section-panel/section-panel.fragment';
import {VideoFragment} from '@amblique/contentful/app/contentful/fragments/video/video.fragment';

export const FullMediaCarouselFragment = gql`
  ${BaseMediaCarouselFragment}
  ${CarouselItemFragment}
  ${ImageFragment}
  ${RichTextBlockFragment}
  ${SectionPanelFragment}
  ${VideoFragment}

  fragment FullMediaCarouselFragment on MediaCarousel {
    ...BaseMediaCarouselFragment

    imagesCollection {
      items {
        __typename
        ... on CarouselItem {
          ...CarouselItemFragment
        }
        ... on Image {
          ...ImageFragment
        }
        ... on RichTextBlock {
          ...RichTextBlockFragment
        }
        ... on SectionPanel {
          ...SectionPanelFragment
        }
        ... on Video {
          ...VideoFragment
        }
      }
    }
    thumbnailsCollection {
      items {
        __typename
        ... on Image {
          ...ImageFragment
        }
        ... on RichTextBlock {
          ...RichTextBlockFragment
        }
        ... on SectionPanel {
          ...SectionPanelFragment
        }
        ... on Video {
          ...VideoFragment
        }
      }
    }
  }
`;
